// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__EFrCR","time":"Timer_time__LgfOT"};